import { render } from "./EmployeeDetailsCard.vue?vue&type=template&id=496aa2d6"
import script from "./EmployeeDetailsCard.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__